import './constants/colors.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'; 
import {BrowserRouter, Routes, Route, } from 'react-router-dom';
import { useEffect} from 'react';
import Home from './pages/orderTrip/Home'
import DriverHome from './pages/taxiDriver/DriverHome';
import NewDone from './pages/orderTrip/NewDone'
import EndPage from './pages/orderTrip/EndPage'
import MainAdmin from './pages/admin/MainAdmin';
import Schedule from './pages/admin/Schedule';
import InvoiceForDriver from './pages/InvoiceForDriver'
import Graf from './pages/admin/Graf';
import Contract from './pages/admin/Contract';
import NewApp from './pages/NewApp';
import DriverRoadHistory from './pages/admin/DriverRoadHistory'
import Test from './pages/test';
import UserList from './pages/admin/users/UserList';



const server = process.env.REACT_APP_SERVER_ADRES;


// APP //
function App() {
  
  useEffect(() => {
    document.title = "Taxi";
  }, []);


  return (
      <div>
        <BrowserRouter>
            <Routes>
              {/* ADMIN */}
              <Route path="/admin" element={ <MainAdmin server={server}/> } />
              <Route path="/admin/sichty" element={ <Schedule server={server}/> } />
              <Route path="/admin/graf" element={ <Graf server={server} /> } />
              <Route path="/admin/driverRoadHistory" element={ <DriverRoadHistory server={server} /> } />
              <Route path="/admin/smlouvy/:tokenOfContract?" element={ <Contract server={server} /> } />
              <Route path="/admin/users" element={ <UserList server={server} /> } />

              <Route path="/centrala" element={ <MainAdmin server={server} cetral={true}/> } />
              <Route path="/test" element={ <Test /> } />

              <Route path="/" element={ <NewApp /> } />
              <Route path="/done/:tokenOfTrip" element={ <NewDone /> } />
              <Route path="/end/:tokenOfTrip" element={ <EndPage /> } />
              <Route path='/driver' element={ <DriverHome />} />
              <Route path='/invoice/:token' element={ <InvoiceForDriver server={server}/>} />

            </Routes>
        </BrowserRouter>
      </div>
  );
}

export default App;
